import React from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter as Router } from 'react-router-dom'

import '@pet-notify/ui/src/reset.css'
import '@pet-notify/ui/src/main.css'
import '@pet-notify/ui/src/spacing.css'
import 'style.css'

import { NotificationProvider } from 'contexts/notification'
import { StripeProvider } from 'contexts/stripe'
import App from 'components/App'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})

const container = document.getElementById('root')

if (container) {
  const root = createRoot(container)

  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <Router>
          <StripeProvider>
            <NotificationProvider>
              <App />
            </NotificationProvider>
          </StripeProvider>
        </Router>
      </QueryClientProvider>
    </React.StrictMode>,
  )
}
